export default {
  FLIGHT: 'flight',
  TRAIN: 'train',
  CRUISE: 'cruise',
  FERRY: 'ferry',
};



// WEBPACK FOOTER //
// ./src/variables/transportTypes.js